/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { ListAgentDeptResponse as AgentApiContractAgentDeptListAgentDeptResponse } from '../../models/AgentApi/Contract/AgentDept/list-agent-dept-response';

export interface ApiAgentListAgentDeptGet$Plain$Params {

/**
 * Interface language. if not defined then system default language
 */
  lang?: string;

/**
 * * agent id
 */
  slrId?: number;
}

export function apiAgentListAgentDeptGet$Plain(http: HttpClient, rootUrl: string, params?: ApiAgentListAgentDeptGet$Plain$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<AgentApiContractAgentDeptListAgentDeptResponse>>> {
  const rb = new RequestBuilder(rootUrl, apiAgentListAgentDeptGet$Plain.PATH, 'get');
  if (params) {
    rb.query('lang', params.lang, {});
    rb.query('slrId', params.slrId, {});
  }

  return http.request(
    rb.build({ responseType: 'text', accept: 'text/plain', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<Array<AgentApiContractAgentDeptListAgentDeptResponse>>;
    })
  );
}

apiAgentListAgentDeptGet$Plain.PATH = '/api/Agent/ListAgentDept';
